import { Button, ButtonProps, ButtonVariants } from '../..'
import { ArrowLeftIcon } from '../../../icons'
import React, { FC } from 'react'
import { LinkAsButton } from '../../Link/LinkAsButton'

interface BackButtonProps extends Omit<ButtonProps, 'variant' | 'icon'> {}

export const BackButton: FC<BackButtonProps> = ({ ...props }): JSX.Element => {
    if (props.href) {
        return (
            <LinkAsButton
                data-testid="back-button"
                variant={ButtonVariants.QUIET}
                icon={<ArrowLeftIcon />}
                {...props}
            />
        )
    }

    return <Button data-testid="back-button" variant={ButtonVariants.QUIET} icon={<ArrowLeftIcon />} {...props} />
}
